/**
 * ts and vue file cannot have the same name, such as 
 * ecoplant.ts and ecoplant.vue cannot co-exist
 */
import { Component } from "vue-property-decorator";
import Feature from "ol/Feature";
import AppBase from "./app.base";
import { User } from "@/components/User";
import { Extent, IMapLayer, IMapLayerSource, 
         ICodeList, IInfoSchema, IInfoSchemaItem, IInfoProperty,
         IThaiArea, IGeoJSON } from "@/components/map/types";
import { ITreeList, EContactStatus } from "@/components/shared/types";

import { createDate, parseValue } from "@/common/utils";

import { sortObjectArray, isNumeric } from "@/common/utils";
import { APP_URL } from "@/common/http";
import TEST_DATA from "@/components/map/data/test-data"

@Component
export default class GISagroBase extends AppBase {
  cropSuitability:{[key:string] : any} = {};
  //cropListLulc:ICodeList[] = [];

  setLayervisibility(mapSources:IMapLayerSource[], visibility) {
    mapSources.forEach((ms) => {
      if (ms.nativeLayer) {
        ms.nativeLayer.setVisible(visibility);
      }
    });
  }

  async fetchCropSuitability() {
    try {
      let data = await this.User.requestResource('codelist/crop_suitability');
      data.forEach((crop) => {
        this.cropSuitability[crop.name] = 'ไม่มีข้อมูล'; //'n/a';
      });
    } catch (error) {}
  }

  setPickedDate(i,j) {
    this.mapInfo.items[i].properties[j].value = this.$refs['datepicker-'+i+'-'+j][0].inputDate;
  }

  isMultiLine(prop:any) : boolean {
    return prop.ctrlType=='textarea' || 
           ((!prop.dataType || prop.dataType=='text') && !prop.canEdit);
  }
}